export default __webpack_public_path__ + "static/media/mobileBackground.2ca07899.jpg";